import { useEffect, useState } from "react";
import { api as defaultApi } from "../../api";

const normalizeLineups = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.response)) return payload.response;
  if (Array.isArray(payload?.lineups)) return payload.lineups;
  return [];
};

/** Public API-Football match statistics: { teams: [home, away] } or null when not published. */
export function useMatchStats(fixtureId, api = defaultApi) {
  const [state, setState] = useState({ loading: true, teams: null, error: "" });
  useEffect(() => {
    if (!fixtureId) return undefined;
    let alive = true;
    setState({ loading: true, teams: null, error: "" });
    api
      .get("/football/match-stats", { params: { fixture_id: fixtureId, period: "all" } })
      .then(({ data }) => {
        const teams = Array.isArray(data?.teams) && data.teams.length === 2 ? data.teams : null;
        const hasValues = teams?.some((t) => (t.statistics || []).some((s) => s.value !== null && s.value !== undefined));
        if (alive) setState({ loading: false, teams: hasValues ? teams : null, source: data?.source, error: "" });
      })
      .catch(() => alive && setState({ loading: false, teams: null, error: "Match statistics are not available yet." }));
    return () => {
      alive = false;
    };
  }, [fixtureId, api]);
  return state;
}

/** Lineups with the fixture payload as fallback; flags predicted lineups. */
export function useLineups(fixtureId, fallback = null, api = defaultApi) {
  const [state, setState] = useState({ loading: true, lineups: [], predicted: false, error: "" });
  useEffect(() => {
    if (!fixtureId) return undefined;
    let alive = true;
    api
      .get("/football/lineups", { params: { fixture_id: fixtureId } })
      .then(({ data }) => {
        const primary = normalizeLineups(data);
        const lineups = primary.length ? primary : normalizeLineups(fallback);
        if (alive) setState({ loading: false, lineups, predicted: Boolean(data?.predicted), error: "" });
      })
      .catch(() => {
        const lineups = normalizeLineups(fallback);
        if (alive) setState({ loading: false, lineups, predicted: false, error: lineups.length ? "" : "Failed to load lineups." });
      });
    return () => {
      alive = false;
    };
  }, [fixtureId, fallback, api]);
  return state;
}
